import { Component, OnInit, ViewEncapsulation } from '@angular/core';

@Component({
  selector: 'pt-sidebar',
  templateUrl: './sidebar.component.html',
  styleUrls: ['./sidebar.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class SidebarComponent implements OnInit {
  open = true;

  constructor() { }

  ngOnInit() {
  }

}
